<template>
  <Button
    class="with-hover-text"
    :class="btnClasses"
    @click.prevent.stop="toggleFollow"
    :loading="loader"
    v-if="user && user.id != idToFollow"
  >
    <template v-if="localFollowed">
      <span class="text">Seguindo</span>
      <span class="hover-text">Unfollow</span>
    </template>
    <template v-else>
      Seguir
    </template>
  </Button>
</template>

<script>

import FollowsService from '@/modules/follows/services/follows-service'
import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button'

export default {
  name: 'FollowButton',
  props: ['idToFollow', 'isFollowed', 'color'],
  components: {
    Button
  },
  data () {
    return {
      loader: false,
      localFollowed: false
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    btnClasses () {
      const array = [
        {
          active: this.localFollowed,
          'background-hover-color4': this.localFollowed
        }
      ]
      const color = this.color ? this.color : 'btn-outline-color2'
      array.push(color)
      return array
    }
  },
  created () {
    this.localFollowed = this.isFollowed
  },
  watch: {
    isFollowed (newValue, oldValue) {
      this.localFollowed = newValue
    }
  },
  methods: {
    async toggleFollow () {
      this.loader = true
      try {
        const action = this.localFollowed ? 'destroy' : 'create'
        await FollowsService.toggleFollow(this.idToFollow, action)
        this.localFollowed = !this.localFollowed
        this.$emit('follow-toggled', this.localFollowed)
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
